import React from 'react';
import style from './style.scss';

class SearchCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <form className="search-category-S">
        <div className='search-input-group'>
          <label className='group-title'>Tên sản phẩm</label>
          <input className='group-input' type='text' placeholder='Nhập tên sản phẩm...'/>
        </div>
        <div className='search-input-group'>
          <label className='group-title'>Lĩnh vực</label>
          <input className='group-input' type='text' placeholder='Nhập lĩnh vực...'/>
        </div>
        <div className='search-input-group'>
          <label className='group-title'>Tên doanh nghiệp</label>
          <input className='group-input' type='text' placeholder='Nhập tên doanh nghiệp...'/>
        </div>
        <div className='search-input-group'>
          <label className='group-title'>Mã sản phẩm</label>
          <input className='group-input' type='text' placeholder='Nhập mã sản phẩm...'/>
        </div>
        <button className='btn-search-category' type='submit'>Tìm kiếm</button>
      </form>
    );
  }
}

export default SearchCategory;


// WEBPACK FOOTER //
// ./components/category-detail/search-category/SearchCategory.jsx